import React from "react";

interface FooterProps {
  className?: string;
}

const Footer: React.FC<FooterProps> = ({ className }) => {
  return (
    <footer
      className={`bg-slate-50 font-montserrat border-t-4
      [border-image:linear-gradient(to_right,#dc2626,#ef4444,#fca5a5)_1]
      ${className}`}>
      <div className="max-w-7xl mx-auto max-sm:px-4 px-8 py-14">
        {/* ================= MAIN FOOTER ================= */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* ===== LOGO + PENYELENGGARA (PALING KIRI) ===== */}
          <div className="flex flex-col items-center md:items-start text-center md:text-left">
            <img src="/images/logo/logo_pm.png" alt="Logo Kementerian Pemberdayaan Masyarakat" className="h-20 md:h-24 object-contain mb-4" />
            <p className="text-gray-700 text-sm md:text-sm font-medium leading-snug">
              Diselenggarakan oleh
              <br />
              <span className="font-semibold text-gray-900">
                Kementerian Koordinator Bidang <br /> Pemberdayaan Masyarakat{" "}
              </span>
            </p>
          </div>

          {/* ===== MENU 1 ===== */}
          <div className="text-center md:text-left">
            <h4 className="font-semibold text-gray-900 mb-4">Tentang Platform</h4>
            <ul className="space-y-2 text-gray-600 text-sm">
              <li>Tentang Kami</li>
              <li>Visi & Misi</li>
              <li>Program Nasional</li>
              <li>Kolaborasi</li>
            </ul>
          </div>

          {/* ===== MENU 2 ===== */}
          <div className="text-center md:text-left">
            <h4 className="font-semibold text-gray-900 mb-4">Layanan</h4>
            <ul className="space-y-2 text-gray-600 text-sm">
              <li>Data Sosial Terpadu</li>
              <li>Pemberdayaan UMKM</li>
              <li>Kolaborasi NGO</li>
              <li>Bantuan & CSR</li>
            </ul>
          </div>

          {/* ===== KONTAK ===== */}
          <div className="text-center md:text-left">
            <h4 className="font-semibold text-gray-900 mb-4">Kontak</h4>
            <p className="text-gray-600 text-sm leading-relaxed">
              Gedung Kementerian Pemberdayaan Masyarakat <br />
              Jl. Medan Merdeka Barat No. 03 <br />
              Jakarta Pusat, Indonesia
            </p>
            <p className="mt-3 text-gray-700 text-sm font-medium">Telp: (+62) 21 345 9444</p>
          </div>
        </div>
      </div>

      {/* ================= COPYRIGHT ================= */}
      <div className="border-t border-gray-200 bg-slate-100">
        <div className="text-center py-5 text-[12px] md:text-sm text-gray-600">
          <p className="font-medium">
            © 2026 <span className="font-bilbo text-red-600">Bangkit Berdaya</span> | All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
